import { createRouter, createWebHistory } from "vue-router";

import index from "@/views/Pc/index";

/**
 * 创建路由对象
 */
const routes_PC = [
  {
    path: "/",
    meta: {
      title: "Yuliverse",
    },
    component: index,
  },
  {
    path: "/activity", //碎片收集活动
    meta: {
      title: "Yuliverse",
    },
    component: () => import("@/views/H5/activity"),
  },
  {
    path: "/howToPlay", //净化地脉介绍
    meta: {
      title: "Yuliverse",
    },
    component: () => import("@/views/H5/howToPlay"),
  },
  {
    path: "/chipHowToPlay", //芯片玩法介绍
    meta: {
      title: "Yuliverse",
    },
    component: () => import("@/views/H5/chipHowToPlay"),
  },
  {
    path: "/gainEntryExplain", //yuli增益词条介绍
    meta: {
      title: "Yuliverse",
    },
    component: () => import("@/views/H5/gainEntryExplain"),
  },
  {
    path: "/attributes", //芯片属性详情
    meta: {
      title: "Yuliverse",
    },
    component: () => import("@/views/H5/attributesDetail"),
  },
  {
    path: "/storage", //储蓄罐活动
    meta: {
      title: "Yuliverse",
    },
    component: () => import("@/views/H5/storageActivity"),
  },
  {
    path: "/weeklyTask", //周期任务
    meta: {
      title: "Yuliverse",
    },
    component: () => import("@/views/H5/weeklyTask"),
  },
  {
    path: "/kudasaiChristmas", //圣诞联名活动
    meta: {
      title: "Yuliverse",
    },
    component: () => import("@/views/H5/kudasaiChristmas"),
  },
  {
    path: "/kudasaiChristmas2", //圣诞联名活动2
    meta: {
      title: "Yuliverse",
    },
    component: () => import("@/components/SlotMachine2/index"),
  },
  {
    path: "/blessedGift", //圣诞联名活动
    meta: {
      title: "Yuliverse",
    },
    component: () => import("@/views/H5/kudasaiChristmas"),
  },
  {
    path: "/PrivacyPolicy", //隐私政策
    meta: {
      title: "Metaport Yuliverse Privacy Policy",
    },
    component: () => import("@/views/Pc/documents/PrivacyPolicy.vue"),
  },
  {
    path: "/Agreement", //用户协议
    meta: {
      title: "End User License Agreement",
    },
    component: () => import("@/views/Pc/documents/Agreement.vue"),
  },
  {
    path: "/GuideRole/:id", //角色天赋和技能介绍
    meta: {
      title: "GuideRole",
    },
    // component: () => import("@/views/H5/guideRole.vue"),
    component: () => import("@/components/GuideRole/index.vue"),
    props: true,
  },
  {
    path: "/badgeWall", //徽章墙（成就列表）
    meta: {
      title: "Achievements",
    },
    component: () => import("@/views/H5/badgeWall"),
  },
  {
    path: "/CyberportCoupon", //数码港餐券活动
    meta: {
      title: "CyberportCoupon",
    },
    component: () => import("@/components/LM_EVENT/CyberportCoupon/index.vue"),
  },
  {
    path: "/CyberportCoupon2shop", //数码港餐券活动-商家扫码端
    meta: {
      title: "Yuliverse Clip System",
    },
    component: () =>
      import("@/components/LM_EVENT/CyberportCoupon/shop/index.vue"),
  },
  {
    path: "/ShopRank", //商店排行榜
    meta: {
      title: "Yuliverse Shop Rank",
    },
    component: () => import("@/components/ShopRank/index.vue"),
  },
  {
    path: "/AirdropPasscard", //passcard空投
    meta: {
      title: "Passcard Airdrop",
    },
    component: () => import("@/components/AirdropPasscard/index.vue"),
  },
  {
    path: "/hkdirl_yuliverse", //限时活动-HKDIRL
    meta: {
      title: "Yuliverse",
    },
    component: () => import("@/components/LM_EVENT/HK_DIRL_EVENT/index.vue"),
  },
  {
    path: "/yuliStaking",
    meta: {
      title: "Yuli Staking",
    },
    component: () => import("@/views/H5/yuliStaking"),
  },
];

const routes = [...routes_PC];
//创建路由
const router = createRouter({
  history: createWebHistory(),
  routes, //定义的路由
});
// 路由拦截操作
router.beforeEach((to, from, next) => {
  // 拦截标题配置
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});
export default router;
